import { render, staticRenderFns } from "./personalityTest.vue?vue&type=template&id=1ef590a7"
import script from "./personalityTest.vue?vue&type=script&lang=js"
export * from "./personalityTest.vue?vue&type=script&lang=js"
import style0 from "./personalityTest.vue?vue&type=style&index=0&id=1ef590a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports